import React from 'react';
import Icon from '../Icon';

export default function KpiCard({ icon, label, value, color = 'blue', onClick, dataTestId }) {
  const colors = {
    blue: { bg: 'rgb(224, 242, 254)', text: 'rgb(2, 132, 199)', icon: 'rgb(2, 132, 199)' },
    teal: { bg: 'rgb(204, 251, 241)', text: 'rgb(14, 116, 144)', icon: 'rgb(14, 116, 144)' },
    green: { bg: 'rgb(220, 252, 231)', text: 'rgb(22, 163, 74)', icon: 'rgb(22, 163, 74)' },
    orange: { bg: 'rgb(254, 243, 199)', text: 'rgb(217, 119, 6)', icon: 'rgb(217, 119, 6)' },
    slate: { bg: 'rgb(241, 245, 249)', text: 'rgb(100, 116, 139)', icon: 'rgb(100, 116, 139)' },
    red: { bg: 'rgb(254, 226, 226)', text: 'rgb(220, 38, 38)', icon: 'rgb(220, 38, 38)' }
  };

  const theme = colors[color] || colors.blue;

  return (
    <div
      data-testid={dataTestId}
      onClick={onClick}
      style={{
        background: '#fff',
        border: '1px solid rgb(226, 232, 240)',
        borderRadius: 12,
        padding: '20px 24px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow 0.2s, border-color 0.2s',
        ...(onClick && {
          ':hover': {
            boxShadow: '0 10px 30px rgba(2, 6, 23, 0.08)',
            borderColor: theme.icon
          }
        })
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.boxShadow = '0 10px 30px rgba(2, 6, 23, 0.08)';
          e.currentTarget.style.borderColor = theme.icon;
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.borderColor = 'rgb(226, 232, 240)';
        }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: theme.bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.icon
          }}
        >
          <Icon name={icon} style={{ fontSize: 20 }} />
        </div>
        <div style={{ fontSize: 13, fontWeight: 500, color: 'rgb(100, 116, 139)' }}>
          {label}
        </div>
      </div>
      <div
        style={{
          fontSize: 32,
          fontWeight: 700,
          fontFamily: "'Space Grotesk', sans-serif",
          color: theme.text,
          fontVariantNumeric: 'tabular-nums'
        }}
      >
        {value}
      </div>
    </div>
  );
}
